import React, { useState } from "react";
import {
  TextField,
  Chip,
  Autocomplete,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Box,
  Button
} from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/ViewList";

const UserControls = ({
  searchTerm,
  setSearchTerm,
  selectedTags,
  setSelectedTags,
  sortMode,
  setSortMode,
  viewMode,
  setViewMode,
  allTags
}) => {
  const [tagInputValue, setTagInputValue] = useState("");

  const handleTagAdd = (event, value) => {
    if (value && !selectedTags.includes(value)) {
      setSelectedTags([...selectedTags, value]);
    }
    setTagInputValue("");
  };

  const handleTagDelete = (tagToDelete) => {
    setSelectedTags(selectedTags.filter(tag => tag !== tagToDelete));
  };

  const handleClearAll = () => {
    setSelectedTags([]);
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", md: "center" }}
        flexWrap="wrap"
      >
        <TextField
          label="Search guides"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          size="small"
          fullWidth
          sx={{ flex: 3 }}
        />

        <Autocomplete
          options={allTags.filter(tag => !selectedTags.includes(tag))}
          value={null}
          inputValue={tagInputValue}
          onInputChange={(e, val, reason) => {
            if (reason !== "reset") setTagInputValue(val);
          }}
          onChange={handleTagAdd}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Add tag"
              size="small"
              InputProps={{
                ...params.InputProps,
                endAdornment: null // removes the X clear button
              }}
            />
          )}
          size="small"
          fullWidth
          sx={{ flex: 1, minWidth: 75 }}
        />

        <FormControl size="small" variant="standard" sx={{ minWidth: 75, flex: 1 }}>
          <InputLabel>Sort</InputLabel>
          <Select
            value={sortMode}
            label="Sort"
            onChange={(e) => setSortMode(e.target.value)}
          >
            <MenuItem value="default">Default</MenuItem>
            <MenuItem value="asc">A-Z</MenuItem>
            <MenuItem value="desc">Z-A</MenuItem>
          </Select>
        </FormControl>

        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={(e, val) => val && setViewMode(val)}
          size="small"
        >
          <ToggleButton value="card"><GridViewIcon /></ToggleButton>
          <ToggleButton value="list"><ListIcon /></ToggleButton>
        </ToggleButtonGroup>
      </Stack>

      {selectedTags.length > 0 && (
        <Stack
          direction="row"
          spacing={1}
          sx={{ mt: 2, flexWrap: "wrap", alignItems: "center" }}
        >
          {selectedTags.map((tag) => (
            <Chip
              key={tag}
              label={tag}
              onDelete={() => handleTagDelete(tag)}
              size="small"
            />
          ))}
          <Button size="small" onClick={handleClearAll} sx={{ ml: 1 }}>
            Clear All
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default UserControls;
